module.exports = __webpack_public_path__ + "img/coin-stack.92b34976.svg";